"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarGraph = void 0;
/* eslint-disable no-magic-numbers */
/* eslint-disable max-lines-per-function */
const React = __importStar(require("react"));
const bar_1 = require("@nivo/bar");
exports.BarGraph = ({ data, keys, indexName, addFilter, hAxisTitle, vAxisTitle }) => (React.createElement(bar_1.ResponsiveBar, { data: data, keys: keys, indexBy: indexName, margin: { top: 50, right: 130, bottom: 50, left: 60 }, padding: 0.55, colors: ['#e19831'], onClick: (_a) => {
        var node = __rest(_a, []);
        if (node.data && node.data.year) {
            addFilter(node.data.year);
        }
    }, borderColor: { from: 'color', modifiers: [['darker', 1.6]] }, axisTop: null, axisRight: null, axisBottom: {
        tickSize: 5,
        tickPadding: 2,
        tickRotation: 0,
        legend: hAxisTitle,
        legendPosition: 'middle',
        legendOffset: 32,
    }, axisLeft: {
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: vAxisTitle,
        legendPosition: 'middle',
        legendOffset: -55,
    }, enableLabel: false, labelSkipHeight: 31, labelTextColor: { theme: 'background' }, legends: [
        {
            dataFrom: 'keys',
            anchor: 'top-right',
            direction: 'column',
            justify: false,
            translateX: 130,
            translateY: -40,
            itemWidth: 100,
            itemHeight: 20,
            itemsSpacing: 0,
            symbolSize: 20,
            symbolShape: 'circle',
            itemDirection: 'left-to-right',
            effects: [
                {
                    on: 'hover',
                    style: {
                        itemTextColor: '#000000',
                        itemOpacity: 1,
                    },
                },
            ],
        },
    ], animate: true }));
//# sourceMappingURL=data:application/json;base64,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